import { retryUnauthorized } from "@/services/tokenRefresh";
import globalMessage from "@/utils/globalMessage";
import React from "react";
import axios from "axios";

import { Modal, Typography } from "antd";
import sessionManager from "@/services/sessionManager";
import { unregisterSessionAbort } from "@/services/requestLifecycle";
import { ENV } from "@config/env";
import _ from "lodash";

const { backendUrl } = ENV;

export const companyRequest = axios.create({
    baseURL: backendUrl,
    headers: {
        "Content-Type": "application/json",
    },
});

companyRequest.interceptors.request.use(
    (config) => {
        const session = sessionManager.getSessionSnapshot();
        if (session.sessionResetting) {
            return Promise.reject(new Error("Session is resetting"));
        }
        config.__sessionEpoch = session.sessionEpoch;
        config.__requestAccess = session.access;
        const controller = new AbortController();
        config.signal = config.signal || controller.signal;
        config.__unregisterSessionAbort = sessionManager.registerRequestController(controller);
        if (session.access) {
            config.headers["Authorization"] = "Bearer " + session.access;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

//response interceptor to refresh token on receiving token expired
companyRequest.interceptors.response.use(
    (response) => {
        unregisterSessionAbort(response.config);
        // if (response.config.method !== 'get' && !response.config.url.includes('log') && !response.config.url.includes('token/refresh')) {
        //
        //     // api.createLog({
        //     //     status: response.status,
        //     //     type: response.config.method,
        //     //     message: typeof response.config.data === 'string' ? response.config.data : '{}',
        //     //     params: JSON.stringify(response.config.params),
        //     //     url: response.config.url,
        //     //     company: store.getState().Facility.selected.record?.company_id
        //     // })
        // }
        return response;
    },
    function (error) {
        unregisterSessionAbort(error.config);
        // console.log('axios error: ', error.response)
        if (!error.response) {
            return Promise.reject(error);
        }
        if (error.response?.status === 401) return retryUnauthorized(error, companyRequest);
        const originalRequest = error.config;
        if (error.response?.status === 400 || error.response?.status > 401) {
            console.log("error.response.data", error.response.data);
            let error_data = error.response.data;
            let error_data_response = [];

            if (
                typeof error_data !== "object" &&
                error.response.data?.startsWith("<!DOCTYPE html>")
            ) {
                error_data_response = "Server Error";
                globalMessage["error"]({
                    message: error.response.statusText,
                    description: error_data_response.toString(),
                });
            } else if (typeof error_data === "object") {
                let error_messages = [];

                Object.keys(error_data).forEach((key) => {
                    if (error_data[key]?.[0] === "This field must be unique.") {
                        error_messages.push(`${key} already exists.`);
                    } else {
                        globalMessage["error"]({
                            message: error.response.statusText,
                            description: JSON.stringify(error_data[key]),
                        });
                    }
                });

                if (error_messages.length > 0) {
                    Modal.info({
                        title: (
                            <Typography.Title level={4}>
                                Duplicated Field Detected!
                            </Typography.Title>
                        ),
                        wrapClassName: "antd-modal-foot-center",
                        content: (
                            <div>
                                {error_messages.map((message, index) => (
                                    <p key={index}>{message}</p>
                                ))}
                            </div>
                        ),
                        onOk() { },
                    });
                }
            } else if (error.response?.status === 403) {
                globalMessage["error"]({
                    message: 'Forbidden',
                    description: 'You are not authorized to access this resource',
                });
                return
            } else {
                error_data_response = error_data;
                globalMessage["error"]({
                    message: error.response.statusText,
                    description: error_data_response.toString(),
                });
            }

            if (_.get(error.response, "data.detail") === "User has no permission.") {
                window.location.href = "/Dashboard";
                window.alert(_.get(error.response, "data.detail"));
            }
        }

        return Promise.reject(error);
    }
);
